<template>
  <div>
    <el-form ref="form" size="small" :model="formData">
      <el-row :gutter="20" class="mt-3">
        <el-col :span="8">
          <el-form-item :label="$l('table_label_orderNo') || '订单编号'">
            <el-input v-model="formData.orderNo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_platformOrderNo') || '电商平台订单编号'"
          >
            <el-input v-model="formData.platformOrderNo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_subscriber') || '订阅方'">
            <el-input v-model="formData.subscriber" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="$l('table_label_eventName') || '事件名称'">
            <el-input v-model="formData.eventName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_pushStatus') || '推送状态'">
            <el-input v-model="formData.v_pushStatus" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('table_label_maxRetryCount') || '最大重试次数'">
                <el-input v-model="formData.maxRetryCount" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('table_label_retryCount') || '当前重试次数'">
                <el-input v-model="formData.retryCount" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_data') || '订单原始数据'"
            prop="data"
          >
            <el-input
              v-model="formData.data"
              readonly
              type="textarea"
              rows="5"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('table_label_pushResult') || '推送结果'">
            <el-input
              v-model="formData.pushResult"
              type="textarea"
              rows="5"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    subsOrderEventLogCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.subsOrderEventLogCode) return
      this.$api
        .ecomPlatformSubsOrderEvnetLogsDetailApi({
          subsOrderEventLogCode: this.subsOrderEventLogCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
